/**
 * BLOCK: transact-wordpress2
 *
 * Registering a basic block with Gutenberg.
 * Simple block, renders and saves the same content without any interactivity.
 */

//  Import CSS.
import './editor.scss';
import './style.scss';

import classnames from 'classnames';

const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks
import { InnerBlocks, getColorClassName } from '@wordpress/block-editor';
import { useRef } from '@wordpress/element';

/**
 * Register: aa Gutenberg Block.
 *
 * Registers a new block provided a unique name and an object defining its
 * behavior. Once registered, the block is made editor as an option to any
 * editor interface where blocks are implemented.
 *
 * @link https://wordpress.org/gutenberg/handbook/block-api/
 * @param  {string}   name     Block name.
 * @param  {Object}   settings Block settings.
 * @return {?WPBlock}          The block, if it has been successfully
 *                             registered; otherwise `undefined`.
 */
registerBlockType( 'transact/premium-content', {
	// Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
	title: __( 'Transact Premium' ), // Block title.
	icon: 'image-rotate', // Block icon from Dashicons → https://developer.wordpress.org/resource/dashicons/.
	category: 'transact-blocks', // Block category — Group blocks together based on common traits E.g. common, formatting, layout widgets, embed.
	keywords: [
		__( 'transact' ),
		__( 'container' ),
		__( 'wrapper' ),
		__( 'row' ),
		__( 'section' ),
	],

	/**
	 * The edit function describes the structure of your block in the context of the editor.
	 * This represents what the editor will render when the block is used.
	 *
	 * The "edit" property must be a valid function.
	 *
	 * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
	 *
	 * @param {Object} props Props.
	 * @returns {Mixed} JSX Component.
	 */
	edit: ( { hasInnerBlocks, className } ) => {
		const ref = useRef();
		return (
			<div className={ className } ref={ ref }>
				<div className="wp-block-transact__inner-container">
					<InnerBlocks
						renderAppender={
							! hasInnerBlocks &&
							InnerBlocks.ButtonBlockAppender
						}
					/>
				</div>
			</div>
		);
	},

	/**
	 * The save function defines the way in which the different attributes should be combined
	 * into the final markup, which is then serialized by Gutenberg into post_content.
	 *
	 * The "save" property must be specified and must be a valid function.
	 *
	 * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
	 *
	 * @param {Object} props Props.
	 * @returns {Mixed} JSX Frontend HTML.
	 */
	save: ( { attributes } ) => {
		const {
			backgroundColor,
			customBackgroundColor,
			textColor,
			customTextColor,
		} = attributes;

		const backgroundClass = getColorClassName(
			'background-color',
			backgroundColor
		);
		const textClass = getColorClassName( 'color', textColor );
		const className = classnames( backgroundClass, textClass, {
			'has-text-color': textColor || customTextColor,
			'has-background': backgroundColor || customBackgroundColor,
		} );
	
		const styles = {
			backgroundColor: backgroundClass ? undefined : customBackgroundColor,
			color: textClass ? undefined : customTextColor,
		};
		
		return (
			<div className={ className } style={ styles }>
				<div className="wp-block-group__inner-container">
					<InnerBlocks.Content />
				</div>
			</div>
		);
	},
} );



// WEBPACK FOOTER //
// ./src/transact-premium/transact-premium.js